module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/search-092d0d0c7d50f89884344a6106516534.svg";